
/* eslint-disable @typescript-eslint/unbound-method */
import React from 'react';
import AudioVisualiser from './AudioVisualizer';
type AudioAnalyzerProps = {
    audio: any;
};
type AudioAnalyzerState = {
    audioData: any;
};
class AudioAnalyser extends React.Component<AudioAnalyzerProps, AudioAnalyzerState> {
    audioContext: any;

    analyser: any;

    dataArray: any;

    source: any;

    rafId: any;

    constructor(props: { audio: any }) {
        super(props);
        this.state = { audioData: new Uint8Array(0) };
        this.tick = this.tick.bind(this);

    }

    componentDidMount() {
        console.log("audio props", this.props.audio)
        this.audioContext = new (window.AudioContext)();
        this.analyser = this.audioContext.createAnalyser();
        this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
        this.source = this.audioContext.createMediaStreamSource(this.props.audio);
        this.source.connect(this.analyser);
        this.rafId = requestAnimationFrame(this.tick);
    }

    tick() {
        this.analyser.getByteTimeDomainData(this.dataArray);
        this.setState({ audioData: this.dataArray });
        this.rafId = requestAnimationFrame(this.tick);
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.rafId);
        this.analyser.disconnect();
        this.source.disconnect();
    }

    render() {
        return <AudioVisualiser audioData={this.state.audioData} />;
    }
}

export default AudioAnalyser;